module.exports = __webpack_public_path__ + "media/images/alteryx-homepage-0802977db17281dc66863a546369c9fabf939dbe1b90c3348935f0f118eddc00.jpg";